module.exports = "pegasus/assets/icn_4.png";